export default {
  custom_button: {
    add: 'Yes, Add to Order',
  },
};
